import React from 'react';
import Modal from 'react-modal';
import { IconCircleExclamation } from 'adc-ui-components';

const ErrorModal = () => (
  <Modal
    isOpen
    contentLabel="Error"
    appElement={Modal.setAppElement('#root')}
    className={{
      base: 'modal__content',
      afterOpen: '',
      beforeClose: '',
    }}
    overlayClassName={{
      base: 'modal',
      afterOpen: 'modal--is-open',
      beforeClose: '',
    }}
  >
    <div className="card text--center">
      <div className="card__content">
        <IconCircleExclamation className="mb6 svg-icon--42" />
        <div className="hgroup">
          <h2>Looks like something went wrong</h2>
          <p>Please reload the page and try again</p>
        </div>

        <button type="button" className="button button--primary" onClick={() => { window.location.reload(); }}>Reload Now</button>
      </div>
    </div>
  </Modal>
);

export default ErrorModal;
